import { initializeState } from './initialise-state';
import { setPanelState } from './set-panel-state';
import { setShouldRenderReopenSpotlight } from './set-should-render-spotlight';
import { setShouldReopenPanel } from './set-should-reopen-panel';
import { setVotedCards } from './set-voted-cards';

export const actions = {
	initializeState,
	setPanelState,
	setShouldRenderReopenSpotlight,
	setShouldReopenPanel,
	setVotedCards,
} as const;
